var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-item',[_c('v-btn',_vm._b({attrs:{"block":""},domProps:{"textContent":_vm._s(_vm.$attrs.label)},on:{"click":function($event){return _vm.$emit('click')}}},'v-btn',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }